// Phase B's feedback stream (gates B3 targeting and B6 impact and VFX): the targets lab (`?scene=targets`), the
// spike's targeting (soft and lock-on) and the lock button's reveal, joined into main.ts here. The impact director
// itself is ../feedback (the valley mounts it at the merge, on the valley's camera and the combat stream's events).
import { TARGETING_FAULTS } from "@rpg/combat";
import type { FaultGroup } from "../faults";
import { mountTargetsLab, type TargetsLab, type TargetsLabOptions } from "./lab";

export { mountLockButton, mountTargeting, TARGETING_SETTING, type Targeting } from "./targeting";
export type { TargetsLab } from "./lab";

/** The planted defects this stream owns in @rpg/combat's targeting, by their `?faults=` names. */
export const TARGETING_FAULT_NAMES = ["targeting-facing-zero"] as const;

/** The targeting's fault group for the spike's one faults record; reads `?faults=` on creation. */
export function targetingFaultGroup(search = typeof location !== "undefined" ? location.search : ""): FaultGroup {
  const on = (new URLSearchParams(search).get("faults") ?? "").split(",");
  TARGETING_FAULTS.facingWeightZeroed = on.includes("targeting-facing-zero");
  return {
    names: TARGETING_FAULT_NAMES,
    get: () => TARGETING_FAULTS.facingWeightZeroed,
    set: (_n, v) => {
      TARGETING_FAULTS.facingWeightZeroed = v;
    },
  };
}

/** Whether the page asks for the targets lab. */
export const isTargetsScene = (search: string): boolean => new URLSearchParams(search).get("scene") === "targets";

/** The lab when the page asks for it (`?scene=targets`), else null. */
export function targetsLabFor(search: string, o: TargetsLabOptions): TargetsLab | null {
  return isTargetsScene(search) ? mountTargetsLab(o) : null;
}
